import { render, staticRenderFns } from "./ListFlashSale.vue?vue&type=template&id=5f257bf0&"
import script from "./ListFlashSale.vue?vue&type=script&lang=js&"
export * from "./ListFlashSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports